var React = require('react');

function TripodInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"13.93","y":"27.76","width":"12.15","height":"2.53","transform":"translate(49.02 9.02) rotate(90)","key":0}),React.createElement("rect",{"x":"13.24","y":"4.9","width":"13.51","height":"2.42","key":1}),React.createElement("polygon",{"points":"28.05 35.1 20.14 10.61 23.11 10.61 31.02 35.1 28.05 35.1","key":2}),React.createElement("polygon",{"points":"8.98 35.1 16.89 10.61 19.86 10.61 11.95 35.1 8.98 35.1","key":3})]);
}

TripodInline.defaultProps = {"width":"32","height":"32","id":"Warstwa_1","viewBox":"0 0 40 40"};

module.exports = TripodInline;

TripodInline.default = TripodInline;
